import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals, pick, prop, groupBy } from "ramda";
import { TertiarySmall } from "@base-ui";
import { Th, Tr, SortableColumn } from "./organizationslist.styles";
import { arrayAnnotationDate } from "utils/periods";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function OrganizationsHeaders(_ref) {
  var _measurementsWithMeta, _query$sort;
  var query = _ref.query,
    measurementsWithMetadata = _ref.measurementsWithMetadata,
    setQuery = _ref.setQuery;
  var periodLabel = arrayAnnotationDate(query.periodType, query.dateTo) || [];
  var measureIds = Object.keys(groupBy(prop("measureId"), measurementsWithMetadata));
  var multipleSubmeasures = measureIds.length > 1;
  var parentId = (_measurementsWithMeta = measurementsWithMetadata[0]) === null || _measurementsWithMeta === void 0 ? void 0 : _measurementsWithMeta.parentId;
  var sort = ((_query$sort = query.sort) === null || _query$sort === void 0 ? void 0 : _query$sort[parentId]) || query.sort;
  var alphaSort = sort === "alpha" ? "ascending" : sort === "reverseAlpha" ? "descending" : "none";
  var periodSort = sort === "asc" ? "ascending" : sort === "desc" ? "descending" : "none";
  var icon = function icon(sort) {
    return sort === "none" ? "listArrows" : sort === "ascending" ? "sortAsc" : "sortDesc";
  };
  var handleSort = function handleSort(query, column) {
    var sortValue;
    if (column === "alpha") sortValue = sort !== "alpha" ? "alpha" : "reverseAlpha";else sortValue = sort !== "asc" ? "asc" : "desc";

    // if we keep track of sort for a single measure
    if (_typeof(query.sort) !== "object") setQuery({
      sort: sortValue
    });
    // if we keep track of sort for multiple measures
    else setQuery({
      sort: _objectSpread(_objectSpread({}, query.sort), {}, _defineProperty({}, parentId, sortValue))
    });
  };
  return /*#__PURE__*/_jsxs(Tr, {
    "aria-rowindex": "1",
    children: [/*#__PURE__*/_jsx(Th, {
      scope: "col",
      "aria-colindex": "1",
      children: /*#__PURE__*/_jsx(TertiarySmall, {
        className: "png-ignore",
        style: {
          margin: 0
        },
        children: "Ta bort"
      })
    }), /*#__PURE__*/_jsx(Th, {
      scope: "col",
      "aria-sort": alphaSort,
      "aria-colindex": "2",
      children: /*#__PURE__*/_jsxs(SortableColumn, {
        onClick: function onClick() {
          return handleSort(query, "alpha");
        },
        icon: icon(alphaSort),
        active: alphaSort !== "none",
        children: [/*#__PURE__*/_jsx(TertiarySmall, {
          style: {
            margin: 0
          },
          children: "Enheter"
        }), /*#__PURE__*/_jsx("span", {
          className: "hidden-styles",
          children: "Aktivera f\xF6r att sortera kolumnen"
        })]
      })
    }), /*#__PURE__*/_jsx(Th, {
      scope: "col",
      "aria-sort": periodSort,
      "aria-colindex": "3",
      children: /*#__PURE__*/_jsxs(SortableColumn, {
        style: {
          textAlign: "center",
          whiteSpace: "nowrap"
        },
        onClick: function onClick() {
          return handleSort(query, "period");
        },
        icon: icon(periodSort),
        active: periodSort !== "none",
        disabled: multipleSubmeasures,
        children: [/*#__PURE__*/_jsx(TertiarySmall, {
          style: {
            margin: 0
          },
          children: periodLabel === null || periodLabel === void 0 ? void 0 : periodLabel.join(" ")
        }), /*#__PURE__*/_jsx("span", {
          className: "hidden-styles",
          children: "Aktivera f\xF6r att sortera kolumnen"
        })]
      })
    })]
  });
}, function (prev, curr) {
  return equals(pick(["sort", "periodType", "dateTo"], prev.query), pick(["sort", "periodType", "dateTo"], curr.query)) && equals(prev.measurementsWithMetadata, curr.measurementsWithMetadata);
});